import React from 'react';
import { connect } from 'react-redux';

import { dismissPaymentError } from '../reducer';

import { Message } from 'semantic-ui-react';

export class DonationErrorMessageView extends React.Component {

    handleDismiss = () => {
        this.props.dismissError();
    }

    render() {
        const { errorMessage, dismiss } = this.props;
        return (
            <Message
                negative
                onDismiss={dismiss ? this.handleDismiss : undefined}>
                <Message.Header>
                    {errorMessage && errorMessage.HeaderMessage}
                </Message.Header>
                <p>
                    {errorMessage && errorMessage.Message}
                </p>
            </Message>
        );
    }
}


const DonationErrorMessage = connect((state) => ({}),
    (dispatch, ownProps) => {
        return {
            dismissError: () => {
                dispatch(dismissPaymentError());
            },
        };
    })(DonationErrorMessageView);

export default DonationErrorMessage;

